// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  cyc: __t.u64().primaryKey(),
  campaignId: __t.u64().name("campaign_id"),
  state: __t.string(),
  fort: __t.string(),
  front: __t.string(),
  openedAt: __t.timestamp().name("opened_at"),
  endsAt: __t.timestamp().name("ends_at"),
  capsA: __t.u8().name("caps_a"),
  capsB: __t.u8().name("caps_b"),
  capsComA: __t.u8().name("caps_com_a"),
  capsComB: __t.u8().name("caps_com_b"),
  frigA: __t.u8().name("frig_a"),
  frigB: __t.u8().name("frig_b"),
  corvA: __t.u8().name("corv_a"),
  corvB: __t.u8().name("corv_b"),
  gunA: __t.u8().name("gun_a"),
  gunB: __t.u8().name("gun_b"),
  retreatSide: __t.i8().name("retreat_side"),
  winner: __t.string(),
  validated: __t.bool(),
  rounds: __t.u16(),
  seq: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
